import { configureStore } from "@reduxjs/toolkit";
import { myApi } from "./api";
import { myreducer } from "./reducer";
import userReducer from "./userSlice"; // Import the new user slice

// 👇 Our new RTK Query setup
import { exchangeUniApi } from "./exchangeUniApi";

// 👇 New trading-related slices
import ordersReducer from "./ordersSlice";
import positionsReducer from "./positionsSlice";
import watchlistReducer from "./watchlistSlice";
import marketReducer from "./marketSlice";
import accountReducer from "./accountUniSlice";
import notificationsReducer from "./notificationsSlice";

export const store = configureStore({
  reducer: {
    [myApi.reducerPath]: myApi.reducer,
    [myreducer.name]: myreducer.reducer,
    user: userReducer,

    // ✅ Our trading app slices
    [exchangeUniApi.reducerPath]: exchangeUniApi.reducer,
    orders: ordersReducer,
    positions: positionsReducer,
    watchlist: watchlistReducer,
    market: marketReducer,
    account: accountReducer,
    notifications: notificationsReducer,
  },

  middleware: (defaultMiddleware) =>
    defaultMiddleware()
      .concat(myApi.middleware)
      .concat(exchangeUniApi.middleware),
});
